import { render, staticRenderFns } from "./gameVideo.vue?vue&type=template&id=da45188e&"
import script from "./gameVideo.vue?vue&type=script&lang=js&"
export * from "./gameVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da45188e')) {
      api.createRecord('da45188e', component.options)
    } else {
      api.reload('da45188e', component.options)
    }
    module.hot.accept("./gameVideo.vue?vue&type=template&id=da45188e&", function () {
      api.rerender('da45188e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/gameVideo.vue"
export default component.exports